import React, { useEffect, useRef, useState } from "react";
import SearchSelect from "./SearchSelect";
import Loader from "../Loader/Loader";
import TextField from "@mui/material/TextField";
import "./form.scss";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import { MenuItem } from "@mui/material";
import { withTranslation, useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import dateFormat from "dateformat";
import { Button, Empty, notification, Spin, Tooltip } from "antd";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import SaveModal from "../Modal/SaveModal";
import PhoneInput from "react-phone-number-input";
const CustomDisableInput = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#000",
    color: "#000",
  },
  ".MuiInputLabel-formControl.Mui-disabled": {
    WebkitTextFillColor: "#000",
    color: "#000",
  },
}));
function EditForm(props) {
  const [rnd, setRnd] = useState();
  const [rnd1, setRnd1] = useState();
  const [rnd2, setRnd2] = useState();
  const [rnd3, setRnd3] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState();
  const [checkstate, setCheckstate] = useState(true);
  const [checkstate1, setCheckstate1] = useState(true);
  const [checkstate2, setCheckstate2] = useState(true);
  const [checkstate3, setCheckstate3] = useState(true);
  const [text, settext] = useState(<span>{t("last_info")} </span>);
  const [text1, settext1] = useState(<span>{t("last_info")}</span>);
  const [rid, setRid] = useState();
  const [did, setDid] = useState();
  const [pid, setPid] = useState();
  const [mid, setMid] = useState();
  const [applicant, setapplicant] = useState(
    JSON.parse(localStorage.getItem("user"))?.name
  );
  const [rname, setRname] = useState();
  const [radress, setRadress] = useState();
  const [rfax, setRfax] = useState();
  const [rphone, setRphone] = useState();
  const [dname, setDname] = useState();
  const [trade_name, settrade_name] = useState();
  const [structure, setstructure] = useState();
  const [drug_figure, setdrug_figure] = useState();
  const [usage, setusage] = useState();
  const [patent, setpatent] = useState();
  const [pname, setPname] = useState();
  const [padress, setPadress] = useState();
  const [pfax, setPfax] = useState();
  const [pphone, setPphone] = useState();
  const [mname, setMname] = useState();
  const [madress, setMadress] = useState();
  const [mfax, setMfax] = useState();
  const [mphone, setMphone] = useState();
  const [err, setErr] = useState();
  const [rdata, setRdata] = useState([]);
  const [ddata, setDdata] = useState([]);
  const [pdata, setPdata] = useState([]);
  const [mdata, setMdata] = useState([]);
  const [drugd, setDrugd] = useState([]);
  const [repd, setrepd] = useState([]);
  const [drugb, setDrugb] = useState(true);
  const [repb, setrepb] = useState(true);
  const [prepd, setprepd] = useState([]);
  const [prepb, setprepb] = useState(false);
  const [mand, setmand] = useState([]);
  const [manb, setmanb] = useState(false);
  const refdrug = useRef(null);
  const [country, setCountry] = useState();
  const [drugfig, setDrugFig] = useState();

  const onChanges = (e) => {
    setRnd(Math.random());
    if (checkstate) {
      setCheckstate(false);
    } else setCheckstate(true);
    setRid();
    setRname();
    setrepb(!repb);
    for (var member in repd) delete repd[member];
  };
  const onChange1 = (e) => {
    setRnd1(Math.random());
    if (checkstate1) {
      setCheckstate2(true);
      setCheckstate3(true);
      setCheckstate1(false);
      setDrugb(true);
      setmanb(true);
      setprepb(true);
      delete drugd["preparer"];
      for (var member in prepd) delete prepd[member];
      delete drugd["manufacturer"];
      for (var member in mand) delete mand[member];
    } else {
      setMphone();
      setPphone();
      setCheckstate1(true);
      setprepb(false);
      setDrugb(false);
      setmanb(false);
    }
    setErr();
    setDid();
    setDname();
    for (var member in drugd) delete drugd[member];
  };
  const onChange2 = (e) => {
    setRnd2(Math.random());
    if (checkstate2) {
      setCheckstate2(false);
    } else {
      setCheckstate2(true);
    }
    setPid();
    setPname();
    setprepb(!prepb);
    setPphone();

    delete drugd["preparer"];
    for (var member in prepd) delete prepd[member];
    setErr();
  };
  const onChange3 = (e) => {
    setRnd3(Math.random());

    if (checkstate3) {
      setCheckstate3(false);
    } else {
      setCheckstate3(true);
      setMid();
    }
    setErr();
    setMname();
    setmanb(!manb);
    setMphone();

    delete drugd["manufacturer"];
    for (var member in mand) delete mand[member];
  };
  const [editable, setEditable] = useState(false);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  useEffect(() => {
    axios
      .get(url.url + `/application/${props.id}`, { headers: headers() })
      .then((res) => {
        setData(res.data.data);
        if (res.data.data.editable == 1) setEditable(true);
        setrepd(res.data.data.representative);
        setCheckstate(false);
        setDrugd(res.data.data.drug);
        setCheckstate1(false);
        setMphone(res.data.data.drug.manufacturer.phone);
        setPphone(res.data.data.drug.preparer.phone);
      });
  }, []);
  useEffect(() => {
    axios.get(url.url + "/drug/figure", { headers: headers() }).then((res) => {
      setDrugFig(res.data.data);
    });
    axios
      .get(url.url + "/entity?type=representative", { headers: headers() })
      .then((res) => {
        setRdata(res.data.data);
      });
    axios
      .get(url.url + "/entity?type=preparer", { headers: headers() })
      .then((res) => {
        setPdata(res.data.data);
      });
    axios
      .get(url.url + "/entity?type=manufacturer", { headers: headers() })
      .then((res) => {
        setMdata(res.data.data);
      });
    axios.get(url.url + "/drug", { headers: headers() }).then((res) => {
      setDdata(res.data.data);
    });
    axios
      .get(url.url + "/country", { headers: headers() })
      .then((res) => {
        setCountry(res.data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
        toast.error(err.response.data);
      });
  }, []);
  useEffect(() => {
    if (did) {
      axios
        .get(url.url + `/drug/${did}`, { headers: headers() })
        .then((res) => {
          setDrugd(res.data.data);
          setMphone(res.data.data.manufacturer.phone);
          setPphone(res.data.data.preparer.phone);
        });
      setDrugb(true);
    }
  }, [did]);
  useEffect(() => {
    if (rid) {
      axios
        .get(url.url + `/entity/${rid}`, { headers: headers() })
        .then((res) => {
          setrepd(res.data.data);
        });
      setrepb(true);
    }
  }, [rid]);
  useEffect(() => {
    if (pid) {
      axios
        .get(url.url + `/entity/${pid}`, { headers: headers() })
        .then((res) => {
          setprepd(res.data.data);
          setPphone(res.data.data.phone);
        });
      setprepb(true);
    }
  }, [pid]);
  useEffect(() => {
    if (mid) {
      axios
        .get(url.url + `/entity/${mid}`, { headers: headers() })
        .then((res) => {
          setmand(res.data.data);
          setMphone(res.data.data.phone);
        });
      setmanb(true);
    }
  }, [mid]);
  const handleSave = () => {
    const datas = {
      applicant: applicant,
      drug: {},
    };
    datas.drug["country_id"] = document.getElementById("examplecountry").value;
    if (rid) {
      datas.representative_id = rid;
    } else {
      if (rname || radress || rfax || rphone)
        datas.representative = {
          name: rname ? rname : data?.representative.name,
          address: radress ? radress : data?.representative.address,
          fax: rfax ? rfax : data?.representative.fax,
          phone: rphone ? rphone : data?.representative.phone,
        };
      else datas.representative_id = data?.representative.id;
    }
    if (did) {
      datas.drug_id = did;
    } else {
      datas.drug["country_id"] =
        document.getElementById("examplecountry").value;
      if (dname || trade_name || structure || drug_figure || usage || patent)
        datas.drug = {
          ...datas.drug,
          name: dname ? dname : data?.drug.name,
          trade_name: trade_name ? trade_name : data?.drug.trade_name,
          structure: structure ? structure : data?.drug.structure,
          drug_figure_id: document.getElementById("examplefigure").value,
          usage: usage ? usage : data.drug.usage,
          patent: patent ? patent : data?.drug.patent,
        };
      else datas.drug_id = data?.drug.id;
      if (pid) {
        datas.drug.preparer_id = pid;
      } else {
        data.drug.preparer = {
          name: pname,
          address: padress,
          fax: pfax,
          phone: pphone,
          country_id: document.getElementById("preparer_country")?.value || null,
        };
      }
      if (mid) {
        datas.drug.manufacturer_id = mid;
      } else {
        datas.drug["manufacturer"] = {
          name: mname,
          address: madress,
          fax: mfax,
          phone: mphone,
          country_id: document.getElementById("manufacturer_country")?.value || null,
        };
      }
    }

    if (datas.drug_id) {
      delete datas.drug;
    }
    axios
      .put(url.url + `/application/${searchParams.get("id")}`, datas, {
        headers: headers(),
      })
      .then((res) => {
        localStorage.setItem("applic", res.data.data.id);
        if (res.status == 200) {
          setErr();
          toast.success(t("Success!"));
          if (show) {
            if (searchParams.get("con_id"))
              navigate({
                pathname: "/account/applications/instruction",
                search: `?${createSearchParams({
                  id: searchParams.get("id"),
                  con_id: searchParams.get("con_id"),
                })}`,
              });
            else
              navigate({
                pathname: "/account/applications/instruction",
                search: `?${createSearchParams({
                  id: searchParams.get("id"),
                })}`,
              });
            setShow(false);
          }
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
        setErr(err.response.data.errors);
      });
  };
  const [show, setShow] = useState(false);
  const handlenext = () => {
    if (
      rname ||
      radress ||
      rfax ||
      rphone ||
      rid ||
      mname ||
      madress ||
      mfax ||
      mphone ||
      mid ||
      did ||
      pid ||
      dname ||
      trade_name ||
      structure ||
      drug_figure ||
      usage ||
      patent ||
      pname ||
      padress ||
      pfax ||
      pphone ||
      dname ||
      trade_name ||
      structure ||
      drug_figure ||
      usage ||
      patent
    ) {
      setShow(true);
    } else if (searchParams.get("con_id"))
      navigate({
        pathname: "/account/applications/instruction",
        search: `?${createSearchParams({
          id: searchParams.get("id"),
          con_id: searchParams.get("con_id"),
        })}`,
      });
    else
      navigate({
        pathname: "/account/applications/instruction",
        search: `?${createSearchParams({
          id: searchParams.get("id"),
        })}`,
      });
  };
  const handeCancel = () => {
    setShow(false);
    if (searchParams.get("con_id"))
      navigate({
        pathname: "/account/applications/instruction",
        search: `?${createSearchParams({
          id: searchParams.get("id"),
          con_id: searchParams.get("con_id"),
        })}`,
      });
    else
      navigate({
        pathname: "/account/applications/instruction",
        search: `?${createSearchParams({
          id: searchParams.get("id"),
        })}`,
      });
  };

  if (data)
    return (
      <div>
        <SaveModal
          show={show}
          handleCancel={() => handeCancel()}
          handleok={() => handleSave()}
        />
        <div className="form-body-wrapp">
          <div className="frm-con" style={{ width: "100%" }}>
            <FormControl fullWidth>
              <div className="app-edit-title-wrapper">
                <h5 className="app-edit-title">{t("Applicant_Information")}</h5>
              </div>
              {!err?.["applicant"] ? (
                <CustomDisableInput
                  defaultValue={data?.applicant}
                  className="text-field mb-2"
                  fullWidth
                  label={t("Applicant")}
                  variant="standard"
                  type="text"
                  onChange={(e) => setapplicant(e.target.value)}
                />
              ) : (
                <CustomDisableInput
                  error
                  helperText={err?.["applicant"]}
                  defaultValue={data?.applicant}
                  className="text-field mb-2"
                  fullWidth
                  label={t("Applicant")}
                  variant="standard"
                  type="text"
                  onChange={(e) => setapplicant(e.target.value)}
                />
              )}
              <div className="check-lable mb-3">
                <Switch defaultChecked={true} onChange={onChanges} />
                <span> {t("choose_from")} </span>
                <Tooltip
                  className="ml-1"
                  placement="right"
                  title={text}
                  color={"#109cf1"}
                >
                  <InfoCircleOutlined className="icon-inf" />
                </Tooltip>
              </div>
              <div key={rnd}>
                {checkstate ? (
                  err?.["representative.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["representative.name"]}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Representative of the applicant")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRname(e.target.value)}
                      defaultValue={data?.representative.name}
                    />
                  ) : (
                    <CustomDisableInput
                      // defaultValue={data?.representative.name}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Representative of the applicant")}
                      variant="standard"
                      type="text"
                      onChange={(e) => {
                        setRname(e.target.value);
                      }}
                    />
                  )
                ) : (
                  <CustomDisableInput
                    className="text-field mb-2"
                    fullWidth
                    select
                    label={t("Representative of the applicant")}
                    variant="standard"
                    onChange={(e) => setRid(e.target.value)}
                    defaultValue={repd.id}
                  >
                    {rdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                <div key={repd?.address + "repd-Address"}>
                  {!err?.["representative.address"] ? (
                    <CustomDisableInput
                      disabled={repb}
                      defaultValue={repd?.address}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRadress(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["representative.address"]}
                      disabled={repb}
                      defaultValue={repd?.address}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRadress(e.target.value)}
                    />
                  )}
                </div>
                <div key={repd?.fax + "repd-Fax address"}>
                  {!err?.["representative.fax"] ? (
                    <CustomDisableInput
                      disabled={repb}
                      defaultValue={repd?.fax}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRfax(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["representative.fax"]}
                      disabled={repb}
                      defaultValue={repd?.fax}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRfax(e.target.value)}
                    />
                  )}
                </div>
                {/* {err?.["representative.phone"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["representative.phone"]}
                    className="text-field mb-2"
                    fullWidth
                    label={t("Phone number")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setRphone(e.target.value)}
                  />
                ) : ( */}
                <div key={repd?.phone + "Phone number"}>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={repb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["representative.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={repd?.phone}
                    onChange={(e) => setRphone(e)}
                  />
                  {err?.["representative.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["representative.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* )} */}
              </div>
            </FormControl>
            <FormControl fullWidth style={{ marginTop: 50 }}>
              <div className="app-edit-title-wrapper">
                <h5 className="app-edit-title">{t("Drug Information")}</h5>
              </div>
              <div className="check-lable mb-3">
                <Switch defaultChecked={true} onChange={onChange1} />
                <span> {t("choose_from")} </span>

                <Tooltip
                  className="ml-1"
                  placement="right"
                  title={t("last_info")}
                  color={"#109cf1"}
                >
                  <InfoCircleOutlined className="icon-inf" />
                </Tooltip>
              </div>
              <div key={rnd1}>
                {checkstate1 ? (
                  err?.["drug.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.name"]}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Drug")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setDname(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      className="text-field mb-2"
                      fullWidth
                      label={t("Drug")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setDname(e.target.value)}
                      defaultValue={drugd?.name}
                    />
                  )
                ) : (
                  <CustomDisableInput
                    className="text-field mb-2"
                    fullWidth
                    select
                    label={t("Drug")}
                    onChange={(e) => setDid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={drugd.id}
                  >
                    {ddata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                {err?.["drug.trade_name"] ? (
                  <CustomDisableInput
                    className="text-field mb-2"
                    error
                    helperText={err?.["drug.trade_name"]}
                    fullWidth
                    label={t("Trade name")}
                    variant="standard"
                    type="text"
                    onChange={(e) => settrade_name(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.trade_name}>
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.trade_name}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Trade name")}
                      variant="standard"
                      type="text"
                      onChange={(e) => settrade_name(e.target.value)}
                    />
                  </div>
                )}
                <div key={drugd?.structure + "Content"}>
                  {!err?.["drug.structure"] ? (
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.structure}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Content")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setstructure(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.structure"]}
                      disabled={drugb}
                      defaultValue={drugd?.structure}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Content")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setstructure(e.target.value)}
                    />
                  )}
                </div>
                {/* <div key={drugd?.drug_figure + "Drug form"}>
                  {!err?.["drug.drug_figure"] ? (
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.drug_figure}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Drug form")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setdrug_figure(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.drug_figure"]}
                      disabled={drugb}
                      defaultValue={drugd?.drug_figure}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Drug form")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setdrug_figure(e.target.value)}
                    />
                  )}
                </div> */}
                <div key={drugd?.drug_figure + "Drug form"}>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Drug form")}
                  </span>
                  <FormControl
                    disabled={drugb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="examplefigure"
                      options={drugfig}
                      defaultValue={drugb ? `${drugd?.drug_figure?.id}` : "1"}
                    />
                  </FormControl>
                </div>
                <div key={drugd?.usage + "Applicat"}>
                  {!err?.["drug.usage"] ? (
                    <CustomDisableInput
                      ref={refdrug}
                      disabled={drugb}
                      defaultValue={drugd?.usage}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Applicat")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setusage(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.usage"]}
                      ref={refdrug}
                      disabled={drugb}
                      defaultValue={drugd?.usage}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Applicat")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setusage(e.target.value)}
                    />
                  )}
                </div>
                {err?.["drug.patent"] ? (
                  <CustomDisableInput
                    error
                    defaultValue={drugd?.patent}
                    helperText={err?.["drug.patent"]}
                    className="text-field mb-2"
                    fullWidth
                    label={t("Patent")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setpatent(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.patent + "Patent"}>
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.patent}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Patent")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setpatent(e.target.value)}
                    />
                  </div>
                )}
                <div key={drugd?.country + "Drug Country"}>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#90a0b7" } : {}}
                  >
                    {t("Country")}
                  </span>
                  <FormControl
                    disabled={drugb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="examplecountry"
                      options={country?.data}
                        placeholder={t("ln_country_search")}
                      defaultValue={drugb ? `${drugd?.country?.id}` : "1"}
                    />
                  </FormControl>
                </div>
              </div>
              {checkstate1 ? (
                <div className="check-lable">
                  <Switch
                    disabled={drugb}
                    defaultChecked={false}
                    onChange={onChange2}
                  />
                  <span className="tttt"> {t("choose_from")} </span>
                  <Tooltip
                    className="tt"
                    placement="right"
                    title={text}
                    color={"#109cf1"}
                  >
                    <InfoCircleOutlined className="icon-inf" />
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
              <div key={rnd2}>
                {checkstate2 ? (
                  err?.["drug.preparer.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.preparer.name"]}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Preparer")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPname(e.target.value)}
                    />
                  ) : (
                    <div
                      key={
                        drugd.preparer
                          ? drugd.preparer?.name + "Preparer"
                          : prepd?.name + "Preparer"
                      }
                    >
                      <CustomDisableInput
                        disabled={drugd.preparer ? drugb : prepb}
                        defaultValue={
                          drugd.preparer ? drugd.preparer?.name : prepd?.name
                        }
                        className="text-field mb-2"
                        fullWidth
                        label={t("Preparer")}
                        variant="standard"
                        type="text"
                        onChange={(e) => setPname(e.target.value)}
                      />
                    </div>
                  )
                ) : (
                  <CustomDisableInput
                    className="text-field mb-2"
                    fullWidth
                    select
                    label={t("Preparer")}
                    onChange={(e) => setPid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={pdata[0]?.name}
                  >
                    {pdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option?.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.address + "preparerAddress"
                      : prepd?.address + "preparerAddress"
                  }
                >
                  {!err?.["drug.preparer.address"] ? (
                    <CustomDisableInput
                      disabled={drugd.preparer ? drugb : prepb}
                      defaultValue={
                        drugd.preparer
                          ? drugd.preparer?.address
                          : prepd?.address
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPadress(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.preparer.address"]}
                      disabled={drugd.preparer ? drugb : prepb}
                      defaultValue={
                        drugd.preparer
                          ? drugd.preparer?.address
                          : prepd?.address
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPadress(e.target.value)}
                    />
                  )}
                </div>
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.fax + "preparerFax address"
                      : prepd?.fax + "preparerFax address"
                  }
                >
                  {!err?.["drug.preparer.fax"] ? (
                    <CustomDisableInput
                      disabled={drugd.preparer ? drugb : prepb}
                      defaultValue={
                        drugd.preparer ? drugd.preparer?.fax : prepd?.fax
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPfax(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.preparer.fax"]}
                      disabled={drugd.preparer ? drugb : prepb}
                      defaultValue={
                        drugd.preparer ? drugd.preparer?.fax : prepd?.fax
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPfax(e.target.value)}
                    />
                  )}
                </div>
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.phone + "preparerPhone number"
                      : prepd?.phone + "preparerPhone number"
                  }
                >
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={drugd.preparer ? drugb : prepb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["drug.preparer.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={pphone}
                    onChange={(e) => setPphone(e)}
                  />
                  {err?.["drug.preparer.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["drug.preparer.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    key={(drugd.preparer ? drugd.preparer?.country_id : prepd?.country_id) + "preparerCountry"}
                    style={{ marginTop: 12 }}
                  >
                    <span className="titleee">{t("Country")}</span>
                    <FormControl disabled={drugd.preparer ? drugb : prepb} fullWidth className="appp-inp text-field mb-2 mt-2">
                      <SearchSelect
                        id="preparer_country"
                        options={country?.data}
                        placeholder={t("ln_country_search")}
                        defaultValue={(drugd.preparer ? drugd.preparer?.country_id : prepd?.country_id) || ""}
                        allowEmpty
                      />
                    </FormControl>
                  </div>
                </div>
              </div>{" "}
              {checkstate1 ? (
                <div className="check-lable">
                  <Switch
                    disabled={drugb}
                    defaultChecked={false}
                    onChange={onChange3}
                  />
                  <span className="tttt"> {t("choose_from")} </span>
                  <Tooltip
                    placement="right"
                    title={t("last_info")}
                    color={"#109cf1"}
                  >
                    <InfoCircleOutlined className="icon-inf" />
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
              <div key={rnd3}>
                {checkstate3 ? (
                  err?.["drug.manufacturer.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.manufacturer.name"]}
                      className="text-field mb-2"
                      fullWidth
                      label={t("Manufacturer")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMname(e.target.value)}
                    />
                  ) : (
                    <div
                      key={
                        drugd.manufacturer
                          ? drugd.manufacturer?.name + "Manufacturer"
                          : mand?.name + "Manufacturer"
                      }
                    >
                      <CustomDisableInput
                        disabled={drugd.manufacturer ? drugb : manb}
                        defaultValue={
                          drugd.manufacturer
                            ? drugd.manufacturer?.name
                            : mand?.name
                        }
                        className="text-field mb-2"
                        fullWidth
                        label={t("Manufacturer")}
                        variant="standard"
                        type="text"
                        onChange={(e) => setMname(e.target.value)}
                      />
                    </div>
                  )
                ) : (
                  <CustomDisableInput
                    className="text-field mb-2"
                    fullWidth
                    select
                    label={t("Manufacturer")}
                    onChange={(e) => setMid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={mdata[1]?.name}
                  >
                    {mdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                <div
                  key={
                    drugd?.manufacturer
                      ? drugd?.manufacturer?.address + "Address"
                      : mand?.address + "Address"
                  }
                >
                  {!err?.["drug.manufacturer.address"] ? (
                    <CustomDisableInput
                      disabled={drugd.manufacturer ? drugb : manb}
                      defaultValue={
                        drugd.manufacturer
                          ? drugd.manufacturer?.address
                          : mand?.address
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMadress(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.manufacturer.address"]}
                      disabled={drugd.manufacturer ? drugb : manb}
                      defaultValue={
                        drugd.manufacturer
                          ? drugd.manufacturer?.address
                          : mand?.address
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMadress(e.target.value)}
                    />
                  )}
                </div>
                <div
                  key={
                    drugd.manufacturer
                      ? drugd.manufacturer?.fax + "Fax address"
                      : mand?.fax + "Fax address"
                  }
                >
                  {!err?.["drug.manufacturer.fax"] ? (
                    <CustomDisableInput
                      disabled={drugd.manufacturer ? drugb : manb}
                      defaultValue={
                        drugd.manufacturer ? drugd.manufacturer?.fax : mand?.fax
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMfax(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.manufacturer.fax"]}
                      disabled={drugd.manufacturer ? drugb : manb}
                      defaultValue={
                        drugd.manufacturer ? drugd.manufacturer?.fax : mand?.fax
                      }
                      className="text-field mb-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMfax(e.target.value)}
                    />
                  )}
                </div>
                {err?.["drug.manufacturer.phone"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["drug.manufacturer.phone"]}
                    className="text-field mb-2"
                    fullWidth
                    label={t("Phone number")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setMphone(e.target.value)}
                  />
                ) : (
                  <div
                    key={
                      drugd?.manufacturer
                        ? drugd.manufacturer.phone + "Phone number"
                        : mand?.phone + "Phone number"
                    }
                  >
                    <span
                      className="titleee"
                      style={drugb ? { color: "#000" } : {}}
                    >
                      {t("Phone number")}
                    </span>
                    <PhoneInput
                      disabled={drugd.manufacturer ? drugb : manb}
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      className={
                        err?.["drug.manufacturer.phone"]
                          ? "inpp-countryy err-phone"
                          : "inpp-countryy"
                      }
                      international
                      defaultCountry="UZ"
                      value={mphone}
                      onChange={(e) => setMphone(e)}
                    />
                    {err?.["drug.manufacturer.phone"] ? (
                      <div className="invalid-phone">
                        {err?.["drug.manufacturer.phone"]}
                      </div>
                    ) : (
                      ""
                    )}
                  <div
                    key={(drugd.manufacturer ? drugd.manufacturer?.country_id : mand?.country_id) + "manufacturerCountry"}
                    style={{ marginTop: 12 }}
                  >
                    <span className="titleee">{t("Country")}</span>
                    <FormControl disabled={drugd.manufacturer ? drugb : manb} fullWidth className="appp-inp text-field mb-2 mt-2">
                      <SearchSelect
                        id="manufacturer_country"
                        options={country?.data}
                        placeholder={t("ln_country_search")}
                        defaultValue={(drugd.manufacturer ? drugd.manufacturer?.country_id : mand?.country_id) || ""}
                        allowEmpty
                      />
                    </FormControl>
                  </div>
                  </div>
                )}
                <div
                  className="info-header__wrapper date-form text-right"
                  style={{ justifyContent: "flex-end" }}
                >
                  <i className="info-header__icon bx bx-calendar date-icon-form"></i>
                  <span className="info-header__text ">
                    {dateFormat(new Date(), "dd.mm.yyyy")}
                  </span>
                </div>
              </div>
            </FormControl>
          </div>
        </div>

        <div className="row justify-content-end mt-3 mr-1">
          <div className="mr-1">
            <Button
              className="button button-edit-inner"
              type="primary"
              size={18}
              onClick={handlenext}
            >
              {t("Next")}
            </Button>
          </div>
          <div className="mr-1">
            <Button
              className="button button-edit-inner"
              type="primary"
              size={18}
              onClick={handleSave}
            >
              {t("Save")}
            </Button>
          </div>
          <Button
            className="button button-edit-inner"
            type="primary"
            size={18}
            onClick={() => navigate("/account/applications")}
          >
            {t("Cancel")}
          </Button>
        </div>
      </div>
    );
  else
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 500,
          backgroundColor: "white",
          borderRadius: 20,
        }}
      >
        <Loader />
      </div>
    );
}

export default withTranslation()(EditForm);
